<nb-card accent="primary">
    <nb-card-header style="display: flex;flex-direction: row;">
        <div style="flex: 1;">{{ title }}</div>
        <div style="flex: 1;justify-content: end;display: flex;">
            <nb-actions size="small">
                <nb-action icon="more-vertical-outline" (click)="openSummary()"></nb-action>
                <nb-action icon="close-outline" (click)="dismiss()"></nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <ng-container *ngIf="ofbizForm">
        <ubs-ofbiz-form [ofbizForm]="ofbizForm" [title]="title" [parameters]="data" [state] ="state" (resetAction)="resetAction($event)"></ubs-ofbiz-form>
    </ng-container>
    
    <!-- <ng-container *ngIf="form">
        <form (ngSubmit)="onSubmit()" [formGroup]="form" class="container" #container>
            <ng-container *ngFor="let formField of formFields">
                <ubs-ofbiz-form-field [formField]="formField" [form]="form" [parameters]="data"></ubs-ofbiz-form-field>
            </ng-container>
            <div class="form-row">
                <button type="submit" nbButton status="primary" [disabled]="!form.valid" size="small">Submit</button>
            </div>
        </form>
    </ng-container> -->
</nb-card>

